import { render } from "./PaywallHeader.vue?vue&type=template&id=8749e4bc"
import script from "./PaywallHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./PaywallHeader.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Paywall/PaywallHeader.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "8749e4bc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('8749e4bc', __exports__)) {
    api.reload('8749e4bc', __exports__)
  }
  
  module.hot.accept("./PaywallHeader.vue?vue&type=template&id=8749e4bc", () => {
    api.rerender('8749e4bc', render)
  })

}


export default __exports__